export const selectTaxonomyAdmin = (state) => state.taxonomyAdmin.taxonomyAdminData;
export const selectTaxonomyAdminLoading = (state) => state.taxonomyAdmin.loading;